import * as moment from 'moment';
import { RecentContents } from '@@modules/common/recentcontents';
import * as React from 'react';
import { AppTextLabel } from '@@services/i18nservice';
import { toastError } from '@@toasts';
import { actions as userActions } from '@@services/userservice';
import { actions as i18nActions } from '@@services/i18nservice';
import { Changelog } from './appshellchangelog';
import { UserProfilePopinContentSearch } from './appshelluser.popin.contentsearch';
import type { IPopinContentProps } from './appshelluser.popin';
import { connectwith } from '@inwink/react-utils/decorators/connectwith';
import { bindActionCreators } from 'redux';
import { InwinkLoader } from '@@components/ui/inwinkloader';
import { withI18nHelper } from '@inwink/i18n';
import { Entities } from '@inwink/entities/entities';
import { setCookie } from '@@services/cookieservice';

interface IUserProfilePopinContentProps extends IPopinContentProps {
    i18nHelper?: Entities.i18nHelper;
}

interface IUserProfilePopinContentState {
    currentLang: string;
    logoutLoading: boolean;
    stamp: Date;
    advancedClickCount: number;
}

@withI18nHelper()
@connectwith(null, (dispatch) => ({
    i18nActions: bindActionCreators(i18nActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))
export class UserProfilePopinContent extends React.Component<IUserProfilePopinContentProps, IUserProfilePopinContentState> {
    constructor(props: IUserProfilePopinContentProps) {
        super(props);
        this.state = {
            currentLang: props.i18n.currentLanguageCode,
            logoutLoading: false,
            stamp: new Date(),
            advancedClickCount: 0
        };
    }

    componentDidMount() {
        const profile = this.props.user.currentUser && this.props.user.currentUserProfile;
        const showPoping = !profile || !profile.firstname || !profile.lastname || !profile.company;
        if (showPoping) {
            setTimeout(() => this.updateProfile(null), 1000);
        }
    }

    componentDidUpdate(prevProps: Readonly<IUserProfilePopinContentProps>): void {
        if (prevProps.userpopinContext.showPopin !== this.props.userpopinContext.showPopin
            && this.props.userpopinContext.showPopin) {
            this.setState({ stamp: new Date() });
        }
    }

    signout = (arg) => {
        this.setState({
            logoutLoading: true
        }, () => {
            (this.props.userActions.logout() as any).then(() => {
                // nothing, the page will be reload
                this.togglePopin(arg);
            })
                .catch((err) => {
                    this.setState({ logoutLoading: false });
                    console.error('LogoutError', err);
                    toastError(this.props.i18n, "auth.logout.err");
                });
        });
    };

    changeEvent = (arg) => {
        inwink.history.push('/');
        this.togglePopin(arg);
    };

    changeLng(l: string) {
        if ((l !== this.state.currentLang)) {
            this.setState({ currentLang: l }, () => {
                setCookie('currentlang', l);
                const act = this.props.i18nActions.loadLanguage(l) as any;
                act.then(() => {
                    this.props.i18nActions.saveLanguagePreferences();
                });
                moment.locale(l);
            });
        }
    }

    about = (arg) => {
        this.togglePopin(arg);
        this.props.popovermgr.sidemodalPortal(Changelog, {
            event: this.props.event
        }, "changelogmodal");
    };

    selectContent(content, arg: React.MouseEvent<any>) {
        this.togglePopin(arg);
        inwink.history.push(`/${content.element.customerId}/${content.type === "event" ? "e" : "c"}/${content.element.id}`);
    }

    toggleEditTrads = (arg: React.MouseEvent<any>) => {
        arg.preventDefault();
        arg.stopPropagation();
        this.props.userActions.editTrads(!this.props.user.editTrads);
    };

    updateProfile = (arg: React.MouseEvent<any>) => {
        if (arg) {
            arg.preventDefault();
            arg.stopPropagation();
        }
        return import('../userprofile/index').then((mod) => this.props.popovermgr.modalPortal(mod.UserProfileUpdate,
            this.props, "userprofileupdatemodale", { disableOverlayDismiss: true }));
    };

    gotologs = (arg: React.MouseEvent<any>) => {
        this.togglePopin(arg);
        let params = '';
        if (this.props.event && this.props.event.eventid) {
            params = `?eventid=${this.props.event.eventid}`;
        } else if (this.props.community && this.props.community.communityid) {
            params = `?communityid=${this.props.community.communityid}`;
        } else {
            const tenantId = (this.props as any).customer?.currentTenantId;
            if (tenantId) {
                params = `?tenantid=${tenantId}`;
            }
        }
        const path = `/root/logs${params}`;
        const useHash = window.location.href.includes('#');
        const base = window.location.href.split('#')[0];
        const href = useHash ? `${base}#${path}` : `${window.location.origin}${path}`;
        window.open(href, "_blank");
    };

    togglePopin = (arg: React.MouseEvent<any>) => {
        if (arg) {
            arg.preventDefault();
            arg.stopPropagation();
        }

        this.props.userpopinContext.togglePopin();
    };

    render() {
        let edittrads;
        let adminlogs;
        let contentsearch;
        if (this.props.rights?.apprights?.trads?.edit) {
            edittrads = <li key="edit-trads" className="clickable edittradsmenu">
                <button
                    type="button"
                    className="linkstyle"
                    onClick={this.toggleEditTrads}
                >
                    <i className={"edittrads inwink-checked " + (this.props.user.editTrads ? "edit-on" : "edit-off")} />
                    <AppTextLabel i18nService={this.props.i18n} i18n="app.edittrads" />
                </button>
            </li>;
        }

        if (this.props.rights?.apprights?.logs) {
            adminlogs = <li key="admin-logs" className="clickable">
                <button
                    type="button"
                    className="linkstyle"
                    onClick={this.gotologs}
                >
                    <AppTextLabel i18nService={this.props.i18n} i18n="app.logs" />
                </button>
            </li>;
            contentsearch = <li><UserProfilePopinContentSearch {...this.props} /></li>;
        }

        let logoutLoader;
        if (this.state.logoutLoading) {
            logoutLoader = <InwinkLoader message="" />;
        }

        return <div className={"appshell-profile-popin" + (this.props.userpopinContext.showPopin ? " showpopin" : "")}>
            <div className="overlay-profile" onClick={this.togglePopin} />
            <div className="profile-popin">
                <div className="profile-popin-content">
                    <ul className="profile-actions">
                        <li key="current-user" className="currentuser">
                            <div className="icon" onClick={(arg) => {
                                arg.preventDefault();
                                arg.stopPropagation();

                                this.setState((prevState) => {
                                    let newCount = prevState.advancedClickCount + 1;
                                    if (newCount > 4) {
                                        this.props.userActions.activateAdvancedMode();
                                        newCount = 0;
                                    }

                                    return {
                                        advancedClickCount: newCount
                                    };
                                });
                            }}>
                                <i className="inwink-account" />
                            </div>
                            <div className="details">
                                <div className="username">
                                    <button
                                        title={this.props.i18nHelper.translate('userprofile.edit')}
                                        type="button"
                                        className="linkstyle"
                                        onClick={this.updateProfile}
                                    >
                                        {this.props.user.currentUser.fullname}
                                        {this.props.user.advancedMode && <i
                                            title={this.props.i18nHelper.translate('userprofile.advancedmode')}
                                            className='inwink-log-debug accent' />}
                                        <i className="inwink-pencil" />
                                    </button>
                                </div>
                                <div className="logout">
                                    <button
                                        type="button"
                                        className="linkstyle"
                                        style={{ display: "flex" }}
                                        onClick={this.signout}
                                    >
                                        <AppTextLabel i18nService={this.props.i18n} i18n="userprofile.signout" />
                                        {logoutLoader}
                                    </button>
                                </div>
                                <div className="langs">
                                    {
                                        this.props.i18n.supported.map((l, i) => {
                                            return <button
                                                type="button"
                                                key={i}
                                                onClick={() => this.changeLng(l)}
                                                className={(l === this.state.currentLang) ? 'important' : ''}
                                            >
                                                {l.toUpperCase()}
                                            </button>;
                                        })
                                    }
                                </div>
                            </div>
                        </li>
                        {contentsearch}
                        <li key="event-selection" className="eventselection">
                            <AppTextLabel
                                className="changeevent"
                                component="a"
                                onClick={this.changeEvent}
                                i18nService={this.props.i18n}
                                i18n="userprofile.change_project"
                            />

                            <RecentContents
                                {...this.props}
                                maxContents={12}
                                trigger={this.state.stamp}
                            >
                                {(elements) => {
                                    return <>
                                        <div className="recentcontents">
                                            {elements?.map((elmt) => {
                                                return <button
                                                    type="button"
                                                    className={"linkstyle " + elmt.type}
                                                    key={elmt.element.id}
                                                    onClick={(arg) => this.selectContent(elmt, arg)}
                                                >
                                                    <img
                                                        alt="inwink"
                                                        src={(inwink.config.assetsUrl || "/")
                                                            + "assets/inwink/FAVICON_FULLWHITE.svg"}
                                                        className="eventlogo"
                                                    />
                                                    {elmt.element.title || elmt.element.name}
                                                </button>;

                                            })}
                                        </div>
                                    </>;
                                }}
                            </RecentContents>

                        </li>
                        {adminlogs}
                        {edittrads}
                        {inwink.config.inwinkconnect?.url && <li>
                            <a className="linkstyle" href={inwink.config.inwinkconnect.url} target="_blank" rel="noreferrer">
                                <AppTextLabel i18n="userprofile.visitinwinkconnect" />
                            </a>
                        </li>}
                        <li>
                            <a className="linkstyle" href="https://www.inwink.com" target="_blank" rel="noreferrer">
                                <AppTextLabel i18n="userprofile.visitinwink" />
                            </a>
                        </li>
                        <li>
                            <a className="linkstyle" href="https://training.inwink.com/" target="_blank" rel="noreferrer">
                                <AppTextLabel i18n="userprofile.inwinktraining" />
                            </a>
                        </li>
                    </ul>

                </div>
                <button
                    type="button"
                    className="btnclosepopin"
                    onClick={this.togglePopin}
                >
                    <i className="inwink-dialog-cancel" />
                </button>
            </div>
        </div>;
    }
}

export default UserProfilePopinContent;